import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "space-y-6 p-6" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "text-3xl font-bold text-gray-900" }
const _hoisted_4 = {
  key: 0,
  class: "flex items-center justify-center py-12"
}
const _hoisted_5 = { class: "text-red-500 text-sm" }
const _hoisted_6 = { class: "grid grid-cols-1 md:grid-cols-4 gap-4" }
const _hoisted_7 = { class: "flex items-center justify-between" }
const _hoisted_8 = { class: "text-3xl font-bold text-gray-900 mt-2" }
const _hoisted_9 = { class: "w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center" }
const _hoisted_10 = { class: "flex items-center justify-between" }
const _hoisted_11 = { class: "text-3xl font-bold text-green-600 mt-2" }
const _hoisted_12 = { class: "w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center" }
const _hoisted_13 = { class: "flex items-center justify-between" }
const _hoisted_14 = { class: "text-3xl font-bold text-gray-900 mt-2" }
const _hoisted_15 = { class: "w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center" }
const _hoisted_16 = { class: "flex items-center justify-between" }
const _hoisted_17 = { class: "text-3xl font-bold text-gray-900 mt-2" }
const _hoisted_18 = { class: "w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center" }
const _hoisted_19 = { class: "flex w-full items-center justify-between border-t pt-4" }
const _hoisted_20 = { class: "flex items-center py-1 gap-3 bg-white rounded-md px-3" }
const _hoisted_21 = { class: "grid grid-cols-1 md:grid-cols-5 gap-4 border-b p-4" }
const _hoisted_22 = { class: "relative" }
const _hoisted_23 = { class: "overflow-x-auto" }
const _hoisted_24 = { class: "w-full" }
const _hoisted_25 = { class: "divide-y divide-gray-200" }
const _hoisted_26 = { class: "px-6 py-4" }
const _hoisted_27 = { class: "max-w-xs" }
const _hoisted_28 = { class: "font-semibold text-gray-900" }
const _hoisted_29 = { class: "text-sm text-gray-600 line-clamp-2" }
const _hoisted_30 = { class: "px-6 py-4" }
const _hoisted_31 = { class: "font-medium text-gray-900" }
const _hoisted_32 = { class: "text-sm text-gray-600" }
const _hoisted_33 = { class: "px-6 py-4" }
const _hoisted_34 = { class: "flex flex-wrap gap-1 max-w-xs" }
const _hoisted_35 = { class: "px-6 py-4" }
const _hoisted_36 = { class: "text-lg font-bold text-gray-900" }
const _hoisted_37 = { class: "text-sm text-gray-600" }
const _hoisted_38 = { class: "px-6 py-4" }
const _hoisted_39 = { class: "font-medium text-gray-900" }
const _hoisted_40 = { class: "text-sm text-gray-600" }
const _hoisted_41 = { class: "px-6 py-4" }
const _hoisted_42 = { class: "px-6 py-4" }
const _hoisted_43 = { class: "flex items-center gap-2" }
const _hoisted_44 = { class: "text-sm font-medium" }
const _hoisted_45 = { class: "px-6 py-4" }
const _hoisted_46 = {
  key: 0,
  class: "space-y-6 mt-4"
}
const _hoisted_47 = { class: "grid grid-cols-2 gap-4 bg-gray-50 rounded-lg p-4" }
const _hoisted_48 = { class: "font-semibold text-gray-900" }
const _hoisted_49 = { class: "font-semibold text-gray-900" }
const _hoisted_50 = { class: "text-xl font-bold text-blue-600" }
const _hoisted_51 = { class: "font-semibold text-gray-900" }
const _hoisted_52 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_53 = { class: "font-semibold text-gray-900" }
const _hoisted_54 = { class: "text-sm text-gray-600" }
const _hoisted_55 = { class: "text-lg font-semibold mb-3" }
const _hoisted_56 = { class: "max-h-64 overflow-y-auto border rounded-lg" }
const _hoisted_57 = { class: "w-full" }
const _hoisted_58 = { class: "divide-y" }
const _hoisted_59 = { class: "px-4 py-2 text-sm font-medium" }
const _hoisted_60 = { class: "px-4 py-2 text-sm text-gray-600" }
const _hoisted_61 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_62 = { class: "p-3 bg-gray-50 rounded-lg" }
const _hoisted_63 = { class: "font-semibold" }
const _hoisted_64 = { class: "p-3 bg-gray-50 rounded-lg" }
const _hoisted_65 = { class: "font-semibold" }
const _hoisted_66 = { class: "p-3 bg-gray-50 rounded-lg" }
const _hoisted_67 = { class: "font-semibold" }
const _hoisted_68 = { class: "p-3 bg-gray-50 rounded-lg" }
const _hoisted_69 = { class: "font-semibold" }
const _hoisted_70 = {
  key: 0,
  class: "text-center py-12"
}
const _hoisted_71 = {
  key: 0,
  class: "bg-gray-50 px-6 py-4 border-t border-gray-200 flex items-center justify-between"
}
const _hoisted_72 = { class: "text-sm text-gray-700" }
const _hoisted_73 = { class: "font-medium" }
const _hoisted_74 = { class: "font-medium" }
const _hoisted_75 = { class: "font-medium" }
const _hoisted_76 = { class: "flex gap-2" }

import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
} from '@/components/ui/card';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useFetchPerSchemeTariffCodesRates } from "@/hooks/use-tariff-codes";
import { useMedicalSchemesStore } from '@/store/use-medical-schemes-store';
import { useTariffCodeStore } from '@/store/use-tariff-codes-store';
import {
  Activity,
  AlertCircle,
  ArrowLeft,
  Building2,
  DollarSign,
  Eye,
  FileText,
  Merge,
  RefreshCcwDot,
  Search,
  SunsetIcon,
  UploadIcon
} from 'lucide-vue-next';
import { storeToRefs } from 'pinia';
import { computed, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';


// Get route to access params

export default /*@__PURE__*/_defineComponent({
  __name: 'SchemeTariffRatesDashboardView',
  props: {
    schemeId: {}
  },
  setup(__props: any) {

const route = useRoute();

// Router
const router = useRouter();

// Get store
const tariffCodesStore = useTariffCodeStore();
const medicalSchemeStore = useMedicalSchemesStore();

// Destructure state with storeToRefs
const { medicalScheme } = storeToRefs(medicalSchemeStore)

const searchQuery = ref('');
const selectedFunder = ref('');
const selectedStatus = ref('');
const selectedYear = ref('');
const selectedRate = ref<any>(null);

// Props
const props = __props;

// Use schemeId from props or route params
const schemeId = computed(() => props.schemeId || route.params.schemeId as string);

// Pagination
const currentPage = ref(1);
const itemsPerPage = ref(15);

// Fetch tariff codes based on applicable year
const {
  data: fetchedData,
  isLoading, 
  isError, 
  error, 
  refetch 
} = useFetchPerSchemeTariffCodesRates(tariffCodesStore.getApplicableYear, schemeId.value)

// Use computed to reactively access the data
const tariffs = computed(() => fetchedData.value || [])

// Filtered tariffs
const filteredTariffs = computed(() => {
  let filtered = tariffs.value

  // Search filter
  if (searchQuery.value) {
    const query = searchQuery.value.toLowerCase()
    filtered = filtered.filter((tariff: any) =>
      tariff.tariff_code.code.toLowerCase().includes(query) ||
      tariff.tariff_code.code_description.toLowerCase().includes(query) ||
      tariff.funder.name.toLowerCase().includes(query) ||
      tariff.funder.scheme_code.toLowerCase().includes(query)
    )
  }

  // Funder filter
  if (selectedFunder.value && selectedFunder.value !== 'all') {
    filtered = filtered.filter((tariff: any) => tariff.funder.name === selectedFunder.value)
  }

  // Status filter
  if (selectedStatus.value && selectedStatus.value !== 'all') {
    const isActive = selectedStatus.value === 'active'
    filtered = filtered.filter((tariff: any) => tariff.active === isActive)
  }

  // Year filter
  if (selectedYear.value && selectedYear.value !== 'all') {
    filtered = filtered.filter((tariff: any) => tariff.applicable_year.toString() === selectedYear.value)
  }

  return filtered
})

// Unique funders
const uniqueFunders = computed(() => {
  const funders = tariffs.value.map((t: any) => t.funder.name)
  return [...new Set(funders)]
})

// Unique years
const uniqueYears = computed(() => {
  const years = tariffs.value.map((t: any) => t.applicable_year.toString())
  return [...new Set(years)].sort((a, b) => parseInt(b) - parseInt(a))
})

// Stats
const stats = computed(() => ({
  total: filteredTariffs.value.length,
  active: filteredTariffs.value.filter((t: any) => t.active).length,
  avgRate: filteredTariffs.value.length > 0
    ? (filteredTariffs.value.reduce((sum: number, t: any) => sum + t.recommendated_rates, 0) / filteredTariffs.value.length).toFixed(2)
    : '0.00',
  funders: uniqueFunders.value.length
}))

// Pagination
const totalPages = computed(() => {
  return Math.ceil(filteredTariffs.value.length / itemsPerPage.value)
})

const startIndex = computed(() => {
  return (currentPage.value - 1) * itemsPerPage.value
})

const endIndex = computed(() => {
  return startIndex.value + itemsPerPage.value
})

const paginatedTariffs = computed(() => {
  return filteredTariffs.value.slice(startIndex.value, endIndex.value)
})

const displayPages = computed(() => {
  const pages = []
  const maxPagesToShow = 5
  let startPage = Math.max(1, currentPage.value - Math.floor(maxPagesToShow / 2))
  let endPage = Math.min(totalPages.value, startPage + maxPagesToShow - 1)

  if (endPage - startPage < maxPagesToShow - 1) {
    startPage = Math.max(1, endPage - maxPagesToShow + 1)
  }

  for (let i = startPage; i <= endPage; i++) {
    pages.push(i)
  }

  return pages
})

// Computed property for safe access
const hasResults = computed(() => fetchedData.value !== null && fetchedData.value?.length > 0)

// Format currency
const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat('en-ZA', {
    style: 'currency',
    currency: 'ZAR',
  }).format(amount)
}

// Format date
const formatDate = (dateStr: string) => {
  return new Date(dateStr).toLocaleDateString('en-ZA', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
}

// Get status color
const getStatusColor = (active: boolean) => {
  return active ? 'bg-green-500' : 'bg-gray-400'
}

const getBenefitClass = (code: string) => {
  const classes: Record<string, string> = {
    'SO': 'bg-green-100 text-green-800 border-green-200',
    'SI': 'bg-yellow-100 text-yellow-800 border-yellow-200',
    'RO': 'bg-blue-100 text-blue-800 border-blue-200',
    'RI': 'bg-purple-100 text-purple-800 border-purple-200'
  }
  return classes[code] || 'bg-gray-100 text-gray-800 border-gray-200'
}

const resetFilters = () => {
  searchQuery.value = ''
  selectedFunder.value = 'all'
  selectedStatus.value = 'all'
  selectedYear.value = 'all'
  currentPage.value = 1
}

const viewDetails = (tariff: any) => {
  selectedRate.value = tariff
}

const previousPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--
  }
}

const nextPage = () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value++
  }
}

// Handlers
const handleSyncPracticeTypes = () => {
  console.log(`Navigate to Syncing Page`);
  router.push({name: 'SyncPracticesView'});
}

const handleSyncSunset = () => {
  console.log(`Navigate to Syncing Page`);
    router.push({name: 'SunsetTariffCodesView'});
}

const handleMergeHBCTariffCodes = () => {
  console.log(`Navigate to Merge HBC Tariff Codes Page`);
    router.push({name: 'MergeHBCTariffCodesView'});
}

const handleUploadTelephonicCodes = () => {
  console.log(`Navigate to Upload Telephonic Codes Page`);
    router.push({name: 'UploadTelephonicCodesView'});
}

const handleUpdateAllowedQty = () => {
  console.log(`Navigate to Update Allowed Qty Page`);
    router.push({name: 'UpdateAllowedQtyView'});
}
// Optional: Debug watch to see when data changes
watch(fetchedData, (newData) => {
  console.log('Fetched data changed:', newData)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(medicalScheme)?.name) + " Tariff Rates Management", 1),
        _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-gray-600 mt-1" }, "Manage and view tariff codes, rates, and practice types", -1))
      ]),
      _createElementVNode("div", null, [
        _createVNode(_unref(Button), {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back())),
          class: "flex items-center border border-gray-300 bg-gray-200 hover:bg-sky-700 hover:text-white"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ArrowLeft)),
            _cache[8] || (_cache[8] = _createTextVNode(" Back ", -1))
          ]),
          _: 1
        })
      ])
    ]),
    (_unref(isLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[9] || (_cache[9] = [
          _createElementVNode("div", { class: "text-center" }, [
            _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-b-2 border-slate-600 mx-auto mb-4" }),
            _createElementVNode("p", { class: "text-gray-600" }, "Loading Schemes tariff rates...")
          ], -1)
        ]))]))
      : (_unref(isError))
        ? (_openBlock(), _createBlock(_unref(Card), {
            key: 1,
            class: "border-red-200 bg-red-50"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(CardContent), { class: "flex flex-col items-center justify-center py-12" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AlertCircle), { class: "h-12 w-12 text-red-600 mb-4" }),
                  _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-red-600 font-semibold mb-2" }, "Error loading tariff codes", -1)),
                  _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(error)?.message), 1),
                  _createVNode(_unref(Button), {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(refetch)())),
                    variant: "outline",
                    class: "mt-4 border-red-600 text-red-600 hover:bg-red-600 hover:text-white"
                  }, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode(" Retry ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (tariffs.value.length > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_unref(Card), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(CardContent), { class: "pt-6" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", null, [
                            _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-sm font-medium text-gray-600" }, "Total Rates", -1)),
                            _createElementVNode("p", _hoisted_8, _toDisplayString(stats.value.total), 1)
                          ]),
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(_unref(FileText), { class: "h-6 w-6 text-blue-600" })
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Card), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(CardContent), { class: "pt-6" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", null, [
                            _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-sm font-medium text-gray-600" }, "Active Rates", -1)),
                            _createElementVNode("p", _hoisted_11, _toDisplayString(stats.value.active), 1)
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_unref(Activity), { class: "h-6 w-6 text-green-600" })
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Card), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(CardContent), { class: "pt-6" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", null, [
                            _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-sm font-medium text-gray-600" }, "Avg. Rate", -1)),
                            _createElementVNode("p", _hoisted_14, "R" + _toDisplayString(stats.value.avgRate), 1)
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(_unref(DollarSign), { class: "h-6 w-6 text-purple-600" })
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Card), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(CardContent), { class: "pt-6" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", null, [
                            _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-sm font-medium text-gray-600" }, "Funders", -1)),
                            _createElementVNode("p", _hoisted_17, _toDisplayString(stats.value.funders), 1)
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_unref(Building2), { class: "h-6 w-6 text-orange-600" })
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_19, [
                _cache[21] || (_cache[21] = _createElementVNode("div", null, [
                  _createElementVNode("h1", { class: "text-xl" }, "Tariff Rates")
                ], -1)),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_unref(Button), {
                    onClick: handleSyncPracticeTypes,
                    class: "flex text-white bg-sky-800 gap-1 p-1 border border-sky-800 hover:bg-sky-700 hover:text-white"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(RefreshCcwDot), { class: "h-4 w-4" }),
                      _cache[16] || (_cache[16] = _createTextVNode(" Sync Practices ", -1))
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Button), {
                    onClick: handleUploadTelephonicCodes,
                    variant: "outline",
                    class: "gap-1 text-white border-sky-700 bg-sky-800 hover:bg-sky-700 hover:text-white"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(UploadIcon), { class: "h-4 w-4" }),
                      _cache[17] || (_cache[17] = _createTextVNode(" Upload Telephonic Codes ", -1))
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Button), {
                    onClick: handleUpdateAllowedQty,
                    variant: "outline",
                    class: "gap-1 text-white border-sky-700 bg-sky-800 hover:bg-sky-700 hover:text-white"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(UploadIcon), { class: "h-4 w-4" }),
                      _cache[18] || (_cache[18] = _createTextVNode(" Update Allowed Qty ", -1))
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Button), {
                    onClick: handleMergeHBCTariffCodes,
                    variant: "outline",
                    class: "gap-1 text-white border-sky-700 bg-sky-800 hover:bg-sky-700 hover:text-white"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Merge), { class: "h-4 w-4" }),
                      _cache[19] || (_cache[19] = _createTextVNode(" Merge HBC Codes ", -1))
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Button), {
                    onClick: handleSyncSunset,
                    class: "flex text-white bg-sky-800 gap-1 p-1 border border-sky-800 hover:bg-sky-700 hover:text-white"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(SunsetIcon), { class: "h-4 w-4" }),
                      _cache[20] || (_cache[20] = _createTextVNode(" Sunset Tariff Codes ", -1))
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createVNode(_unref(Card), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(CardContent), { class: "p-0" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_unref(Search), { class: "absolute left-3 top-3 h-4 w-4 text-gray-400" }),
                          _createVNode(_unref(Input), {
                            modelValue: searchQuery.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchQuery).value = $event)),
                            placeholder: "Search tariff codes...",
                            class: "pl-9"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createVNode(_unref(Select), {
                          modelValue: selectedFunder.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedFunder).value = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(SelectTrigger), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(SelectValue), { placeholder: "All Funders" })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(SelectContent), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(SelectItem), { value: "all" }, {
                                  default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                    _createTextVNode("All Funders", -1)
                                  ]))]),
                                  _: 1
                                }),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uniqueFunders.value, (funder) => {
                                  return (_openBlock(), _createBlock(_unref(SelectItem), {
                                    key: funder,
                                    value: funder
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(funder), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_unref(Select), {
                          modelValue: selectedYear.value,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedYear).value = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(SelectTrigger), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(SelectValue), { placeholder: "All Years" })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(SelectContent), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(SelectItem), { value: "all" }, {
                                  default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                    _createTextVNode("All Years", -1)
                                  ]))]),
                                  _: 1
                                }),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uniqueYears.value, (year) => {
                                  return (_openBlock(), _createBlock(_unref(SelectItem), {
                                    key: year,
                                    value: year
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(year), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_unref(Select), {
                          modelValue: selectedStatus.value,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedStatus).value = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(SelectTrigger), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(SelectValue), { placeholder: "All Status" })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(SelectContent), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(SelectItem), { value: "all" }, {
                                  default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                    _createTextVNode("All Status", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _createVNode(_unref(SelectItem), { value: "active" }, {
                                  default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                    _createTextVNode("Active", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _createVNode(_unref(SelectItem), { value: "inactive" }, {
                                  default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                    _createTextVNode("Inactive", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_unref(Button), {
                          onClick: resetFilters,
                          variant: "outline",
                          class: "w-full"
                        }, {
                          default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                            _createTextVNode(" Reset Filters ", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("table", _hoisted_24, [
                          _cache[43] || (_cache[43] = _createElementVNode("thead", { class: "bg-gray-50 border-b" }, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", { class: "px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase" }, "Tariff Code"),
                              _createElementVNode("th", { class: "px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase" }, "Funder"),
                              _createElementVNode("th", { class: "px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase" }, "Benefit Types"),
                              _createElementVNode("th", { class: "px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase" }, "Rate"),
                              _createElementVNode("th", { class: "px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase" }, "Limits"),
                              _createElementVNode("th", { class: "px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase" }, "Year"),
                              _createElementVNode("th", { class: "px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase" }, "Status"),
                              _createElementVNode("th", { class: "px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase" }, "Actions")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", _hoisted_25, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedTariffs.value, (tariff) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: tariff.rate_id,
                                class: "hover:bg-gray-50 transition-colors"
                              }, [
                                _createElementVNode("td", _hoisted_26, [
                                  _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("div", _hoisted_28, _toDisplayString(tariff.tariff_code.code), 1),
                                    _createElementVNode("div", _hoisted_29, _toDisplayString(tariff.tariff_code.code_description), 1),
                                    (tariff.tariff_code.is_hbc)
                                      ? (_openBlock(), _createBlock(_unref(Badge), {
                                          key: 0,
                                          variant: "default",
                                          class: "mt-1"
                                        }, {
                                          default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                            _createTextVNode("HBC", -1)
                                          ]))]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_30, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_31, _toDisplayString(tariff.funder.name), 1),
                                    _createElementVNode("div", _hoisted_32, _toDisplayString(tariff.funder.scheme_code), 1)
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_33, [
                                  _createElementVNode("div", _hoisted_34, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tariff.tariff_code.benefit_type.slice(0, 2), (benefit) => {
                                      return (_openBlock(), _createBlock(_unref(Badge), {
                                        key: benefit.id,
                                        variant: "outline",
                                        class: _normalizeClass([getBenefitClass(benefit.code), "text-sm"])
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(benefit.code), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["class"]))
                                    }), 128)),
                                    (tariff.tariff_code.benefit_type.length > 2)
                                      ? (_openBlock(), _createBlock(_unref(Badge), {
                                          key: 0,
                                          variant: "outline",
                                          class: "text-sm bg-gray-100 text-gray-700"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" +" + _toDisplayString(tariff.tariff_code.benefit_type.length - 2), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_35, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_36, _toDisplayString(formatCurrency(tariff.recommendated_rates)), 1),
                                    _createElementVNode("div", _hoisted_37, _toDisplayString(tariff.billing_type.code), 1)
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_38, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_39, _toDisplayString(tariff.applicable_limits), 1),
                                    _createElementVNode("div", _hoisted_40, _toDisplayString(tariff.limit_type.code), 1)
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_41, [
                                  _createVNode(_unref(Badge), { variant: "secondary" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(tariff.applicable_year), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _createElementVNode("td", _hoisted_42, [
                                  _createElementVNode("div", _hoisted_43, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(['w-2 h-2 rounded-full', getStatusColor(tariff.active)])
                                    }, null, 2),
                                    _createElementVNode("span", _hoisted_44, _toDisplayString(tariff.active ? 'Active' : 'Inactive'), 1)
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_45, [
                                  _createVNode(_unref(Dialog), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(DialogTrigger), { "as-child": "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(Button), {
                                            class: "flex border gap-1 items-center border-yellow-500",
                                            variant: "ghost",
                                            size: "sm",
                                            onClick: ($event: any) => (viewDetails(tariff))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(Eye), { class: "h-4 w-4" }),
                                              _cache[29] || (_cache[29] = _createTextVNode(" Details ", -1))
                                            ]),
                                            _: 1
                                          }, 8, ["onClick"])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_unref(DialogContent), { class: "w-[70vw] h-[70vh] max-w-none sm:max-w-none bg-white border-yellow-400 overflow-y-auto" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(DialogHeader), null, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(DialogTitle), null, {
                                                default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                                                  _createTextVNode("Tariff Rate Details", -1)
                                                ]))]),
                                                _: 1
                                              }),
                                              _createVNode(_unref(DialogDescription), null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(" Complete information for " + _toDisplayString(selectedRate.value?.tariff_code?.code), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          (selectedRate.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                                _createElementVNode("div", null, [
                                                  _cache[35] || (_cache[35] = _createElementVNode("h4", { class: "text-lg font-semibold mb-3" }, "Tariff Code Information", -1)),
                                                  _createElementVNode("div", _hoisted_47, [
                                                    _createElementVNode("div", null, [
                                                      _cache[31] || (_cache[31] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Code", -1)),
                                                      _createElementVNode("p", _hoisted_48, _toDisplayString(selectedRate.value.tariff_code.code), 1)
                                                    ]),
                                                    _createElementVNode("div", null, [
                                                      _cache[32] || (_cache[32] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Description", -1)),
                                                      _createElementVNode("p", _hoisted_49, _toDisplayString(selectedRate.value.tariff_code.code_description), 1)
                                                    ]),
                                                    _createElementVNode("div", null, [
                                                      _cache[33] || (_cache[33] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Rate", -1)),
                                                      _createElementVNode("p", _hoisted_50, _toDisplayString(formatCurrency(selectedRate.value.recommendated_rates)), 1)
                                                    ]),
                                                    _createElementVNode("div", null, [
                                                      _cache[34] || (_cache[34] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "HBC", -1)),
                                                      _createElementVNode("p", _hoisted_51, _toDisplayString(selectedRate.value.tariff_code.is_hbc ? 'Yes' : 'No'), 1)
                                                    ])
                                                  ])
                                                ]),
                                                _createElementVNode("div", null, [
                                                  _cache[36] || (_cache[36] = _createElementVNode("h4", { class: "text-lg font-semibold mb-3" }, "Benefit Types", -1)),
                                                  _createElementVNode("div", _hoisted_52, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedRate.value.tariff_code.benefit_type, (benefit) => {
                                                      return (_openBlock(), _createElementBlock("div", {
                                                        key: benefit.id,
                                                        class: "p-3 border rounded-lg"
                                                      }, [
                                                        _createElementVNode("p", _hoisted_53, _toDisplayString(benefit.code), 1),
                                                        _createElementVNode("p", _hoisted_54, _toDisplayString(benefit.code_description), 1)
                                                      ]))
                                                    }), 128))
                                                  ])
                                                ]),
                                                _createElementVNode("div", null, [
                                                  _createElementVNode("h4", _hoisted_55, " Practice Types (" + _toDisplayString(selectedRate.value.practice_type.length) + ") ", 1),
                                                  _createElementVNode("div", _hoisted_56, [
                                                    _createElementVNode("table", _hoisted_57, [
                                                      _cache[37] || (_cache[37] = _createElementVNode("thead", { class: "bg-gray-50 sticky top-0" }, [
                                                        _createElementVNode("tr", null, [
                                                          _createElementVNode("th", { class: "px-4 py-2 text-left text-sm font-semibold text-gray-700" }, "Code"),
                                                          _createElementVNode("th", { class: "px-4 py-2 text-left text-sm font-semibold text-gray-700" }, "Description")
                                                        ])
                                                      ], -1)),
                                                      _createElementVNode("tbody", _hoisted_58, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedRate.value.practice_type, (practice) => {
                                                          return (_openBlock(), _createElementBlock("tr", {
                                                            key: practice.code
                                                          }, [
                                                            _createElementVNode("td", _hoisted_59, _toDisplayString(practice.code), 1),
                                                            _createElementVNode("td", _hoisted_60, _toDisplayString(practice.code_description), 1)
                                                          ]))
                                                        }), 128))
                                                      ])
                                                    ])
                                                  ])
                                                ]),
                                                _createElementVNode("div", null, [
                                                  _cache[42] || (_cache[42] = _createElementVNode("h4", { class: "text-lg font-semibold mb-3" }, "Additional Details", -1)),
                                                  _createElementVNode("div", _hoisted_61, [
                                                    _createElementVNode("div", _hoisted_62, [
                                                      _cache[38] || (_cache[38] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Billing Type", -1)),
                                                      _createElementVNode("p", _hoisted_63, _toDisplayString(selectedRate.value.billing_type.code_description), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_64, [
                                                      _cache[39] || (_cache[39] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Frequency", -1)),
                                                      _createElementVNode("p", _hoisted_65, _toDisplayString(selectedRate.value.frequency.code_description), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_66, [
                                                      _cache[40] || (_cache[40] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Limit Type", -1)),
                                                      _createElementVNode("p", _hoisted_67, _toDisplayString(selectedRate.value.limit_type.code_description), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_68, [
                                                      _cache[41] || (_cache[41] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Applicable Limits", -1)),
                                                      _createElementVNode("p", _hoisted_69, _toDisplayString(selectedRate.value.applicable_limits), 1)
                                                    ])
                                                  ])
                                                ])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1024)
                                ])
                              ]))
                            }), 128))
                          ])
                        ]),
                        (paginatedTariffs.value.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                              _createVNode(_unref(AlertCircle), { class: "h-16 w-16 mx-auto text-gray-400 mb-4" }),
                              _cache[44] || (_cache[44] = _createElementVNode("p", { class: "text-gray-600 text-lg font-medium" }, "No tariff rates found", -1)),
                              _cache[45] || (_cache[45] = _createElementVNode("p", { class: "text-gray-500 text-sm mt-1" }, "Try adjusting your filters", -1))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (filteredTariffs.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                            _createElementVNode("div", _hoisted_72, [
                              _cache[46] || (_cache[46] = _createTextVNode(" Showing ", -1)),
                              _createElementVNode("span", _hoisted_73, _toDisplayString(startIndex.value + 1), 1),
                              _cache[47] || (_cache[47] = _createTextVNode(" to ", -1)),
                              _createElementVNode("span", _hoisted_74, _toDisplayString(Math.min(endIndex.value, filteredTariffs.value.length)), 1),
                              _cache[48] || (_cache[48] = _createTextVNode(" of ", -1)),
                              _createElementVNode("span", _hoisted_75, _toDisplayString(filteredTariffs.value.length), 1),
                              _cache[49] || (_cache[49] = _createTextVNode(" results ", -1))
                            ]),
                            _createElementVNode("div", _hoisted_76, [
                              _createVNode(_unref(Button), {
                                onClick: previousPage,
                                disabled: currentPage.value === 1,
                                variant: "outline",
                                size: "sm"
                              }, {
                                default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                                  _createTextVNode(" Previous ", -1)
                                ]))]),
                                _: 1
                              }, 8, ["disabled"]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayPages.value, (page) => {
                                return (_openBlock(), _createBlock(_unref(Button), {
                                  key: page,
                                  onClick: ($event: any) => (currentPage.value = page),
                                  variant: currentPage.value === page ? 'default' : 'outline',
                                  size: "sm"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(page), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick", "variant"]))
                              }), 128)),
                              _createVNode(_unref(Button), {
                                onClick: nextPage,
                                disabled: currentPage.value === totalPages.value,
                                variant: "outline",
                                size: "sm"
                              }, {
                                default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                                  _createTextVNode(" Next ", -1)
                                ]))]),
                                _: 1
                              }, 8, ["disabled"])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ], 64))
          : (_openBlock(), _createBlock(_unref(Card), { key: 3 }, {
              default: _withCtx(() => [
                _createVNode(_unref(CardContent), { class: "flex flex-col items-center justify-center py-12" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(AlertCircle), { class: "h-12 w-12 text-gray-400 mb-4" }),
                    _cache[53] || (_cache[53] = _createElementVNode("p", { class: "text-gray-500" }, "No tariff data available", -1)),
                    _createVNode(_unref(Button), {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(refetch)())),
                      variant: "outline",
                      class: "mt-4"
                    }, {
                      default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                        _createTextVNode(" Refresh ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
  ]))
}
}

})